__turbopack_context__.v({
  "motionSlot": "BirdFootprints-module__y2830q__motionSlot",
  "reducedStatic": "BirdFootprints-module__y2830q__reducedStatic",
  "root": "BirdFootprints-module__y2830q__root",
});
